import type { ReactNode } from "react";
import SuccessImage from "../../assets/images/SuccessStory.svg";

type Props = {
  title: string;
  description?: ReactNode;
  hideIcon?: boolean;
};

export default function CommonHeader({ title, description, hideIcon }: Props) {
  return (
    <header className="bg-gradient-to-l from-teal-700 to-gray-800 py-20 overflow-x-hidden">
      <div className="container mini-container">
        <div className="flex justify-center items-center">
          <div>
            <h1 className="text-white text-3xl lg:text-5xl font-semibold text-center">
              {title}
            </h1>
            {description && (
              <p className="mt-3 text-center text-white text-base lg:text-lg font-normal">
                {description}
              </p>
            )}
          </div>

          {!hideIcon && (
            <img
              src={SuccessImage}
              alt="Success"
              className="-mt-24 -mr-16 w-20 md:w-28 lg:-mr-32 lg:w-auto hidden md:block"
            />
          )}
        </div>
      </div>
    </header>
  );
}
